import { useEffect, useState } from 'react'
import Confetti from 'react-confetti'
import styled, {useTheme} from 'styled-components'

const Container = styled.div`
height: 100vh;
position: fixed;
top: 0;
left: 0;
z-index: 100;
`

export const Confettis = ({launch}: {launch: boolean}) => {
  const [party, setParty] = useState(true)
  const theme = useTheme()

    useEffect(() => {
    if (launch) {
      setParty(true)
    }
    }, [launch])

  return (
    <Container>
      <Confetti
        style={{ pointerEvents: 'none' }}
        numberOfPieces={party ? 500 : 0}
        colors={[`rgb(${theme.mainColor})`, `rgb(${theme.secondaryColor})`]}
        recycle={false}
        onConfettiComplete={(confetti) => {
          setParty(false)
          confetti?.reset()
        }}
      />
    </Container>
  )
}
